@if (this.label(); as label) {
  <cam-button icon="plus" type="primary" (action)="this.pick()">{{ label | translate }}</cam-button>
} @else if (this.showInActionButton()) {
  <cam-action-button [actions]="this.addActions"> </cam-action-button>
} @else {
  @for (action of this.addActions; track action.label) {
    <cam-button (action)="action.callback()">
      {{ action.label ?? '' | translate }}
    </cam-button>
  }
}
